<template>
  <div class="hellow-you">
    <div class="container">
      <div class="hellow-wrap">
        <div class="hellowWords">
          <h1>{{hello.h1}}</h1>
          <span>{{hello.span}}</span>
          <router-link :to="hello.first_step">
            <Buttons class="btn-primary">Поехали</Buttons>
          </router-link>
          <span v-if="hello.skip" class="prelude" @click="$parent.skip">{{hello.skip}}</span>
        </div>
        <div class="pic">
          <img :src="pic" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  components: {},
  props: ["hello"],
  computed: {
    pic: function() {
      var images = require.context("@/assets/", false, /\.png$/);
      return images("./" + this.hello.pic);
    }
  }
};
</script>

<style lang="scss" scoped>
.hellow-you {
  padding: 80px 0;
  .btn-primary{
    padding: 12px;
    width: 224px;
  }
  .hellow-wrap {
    display: grid;
    grid-template-columns: 1.16fr 2fr;
    grid-gap: 29px;
    text-align: left;
    .hellowWords {
      h1 {
        font-weight: bold;
        font-size: 32px;
        line-height: 40px;
        margin-bottom: 24px;
      }
      span {
        display: block;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 32px;
        &.prelude {
          color: #8e8e8e;
          font-size: 14px;
          line-height: 20px;
          cursor: pointer;
        }
      }
      .btn {
        padding: 12px 0;
        width: 224px;
        margin-bottom: 16px;
      }
    }
  }
}
</style>